export default {
  title: 'Please select questionnaire and email template',
  label: {
    questionnaire: 'Questionnaire',
    emailTemplate: 'Email Template'
  },
  btn: {
    invite: 'Invite'
  },
  message: {
    inviteSuccess: 'Invite Success',
    hasInvited: 'Invited or previously completed questionnaire',
    inviteFail: 'Invite Failed'
  }
}
